import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { useMemo } from 'react';
import { Module } from 'src/domain';
import { selectedGenderMapVar } from 'src/infrastructure/local_state';
import { useCurrentId } from '../useCurrentId';
import { useCurrentModule } from '../useCurrentModule';
import { useScope } from '../useScope';

export const useSelectedGender = (module?: Module) => {
    const [selectedGenderMap] = useReactiveVar(selectedGenderMapVar);
    const scope = useScope();
    const id = useCurrentId();
    const currentModule = useCurrentModule();
    const selectedModule = module ?? currentModule;

    const selectedGender = useMemo(() => {
        if (!scope || !id || !selectedModule) return;

        return selectedGenderMap.get({ id, scope, module: selectedModule });
    }, [id, selectedGenderMap, selectedModule, scope]);

    return selectedGender;
};
